<div class="notification" *ngIf="data.loginInfo[0]?.user_type == 'driver'">
  <div class="d-flex justify-content-between align-items-center">
    <div class="notification-header">
      <h3>Driver Details</h3>
    </div>
    <div class="header-notification">
      <img src="../../../assets/img/icons8-macos-close-60.png" class="close-icons" (click)="close()" />
    </div>
  </div>
  <mat-divider></mat-divider>

  <div class="form">
    <div class="row d-flex align-items-center text-capitalize justify-content-center my-4">
      <div class="col-sm-3">
        <div class="label">Driver Name</div>
      </div>
      <div class="col-sm-3">
        <div class="head">{{ data.username }}</div>
      </div>
      <div class="col-sm-3">
        <div class="label">Profile</div>
      </div>
      <div class="col-sm-3">
        <img src="{{ data.profile_image }}" class="img-fluid" />
      </div>
    </div>

    <div class="row d-flex align-items-center text-capitalize justify-content-start my-4">
      <div class="col-sm-3">
        <div class="label">Mobile Number</div>
      </div>
      <div class="col-sm-3 class-name">
        <div class="head">{{ data.mobile }}</div>
      </div>
    </div>

    <div class="row d-flex align-items-center justify-content-center my-4">
      <div class="col-sm-3">
        <div class="label">Email</div>
      </div>
      <div class="col-sm-3">
        <div class="head">{{ data.email }}</div>
      </div>
      <div class="col-sm-3">
        <div class="label">Status</div>
      </div>
      <div class="col-sm-3 class-name text-capitalize">
        <div class="head">{{ data.loginInfo[0]?.login_status }}</div>
      </div>
    </div>

    <div class="row d-flex align-items-center text-capitalize my-4">
      <div class="col-sm-3">
        <div class="label">Driving License Number</div>
      </div>
      <div class="col-sm-3">
        <div class="head">{{ data.driving_license_number }}</div>
      </div>
      <div class="col-sm-3">
        <div class="label">Created Date</div>
      </div>
      <div class="col-sm-3 class-name">
        <div class="head">{{ data.createdAt | date : "dd-MM-yyyy" }}</div>
      </div>
    </div>
    <div class="row d-flex align-items-center text-capitalize my-4">
      <div class="col-sm-3">
        <div class="label">Known Languages</div>
      </div>
      <div class="col-sm-9">
        <div class="head">{{ data.known_lang }}</div>
      </div>
    </div>
  </div>
</div>

<div class="notification" *ngIf="data.loginInfo[0]?.user_type == 'truckowner'">
  <div class="d-flex justify-content-between align-items-center">
    <div class="notification-header">
      <h3>Truck Owner Details</h3>
    </div>
    <div class="header-notification">
      <img src="../../../assets/img/icons8-macos-close-60.png" class="close-icons" (click)="close()" />
    </div>
  </div>
  <mat-divider></mat-divider>

  <div class="form">
    <div class="row d-flex align-items-center text-capitalize justify-content-center my-4">
      <div class="col-sm-3">
        <div class="label">Truck Owner Name</div>
      </div>
      <div class="col-sm-3">
        <div class="head">{{ data.username }}</div>
      </div>
      <div class="col-sm-3">
        <div class="label">Profile</div>
      </div>
      <div class="col-sm-3">
        <img src="{{ data.profile_pic }}" class="img-fluid" />
      </div>
    </div>

    <div class="row d-flex align-items-center justify-content-center my-4">
      <div class="col-sm-3">
        <div class="label">Mobile Number</div>
      </div>
      <div class="col-sm-3 class-name">
        <div class="head">{{ data.mobile }}</div>
      </div>
      <div class="col-sm-3">
        <div class="label">Email</div>
      </div>
      <div class="col-sm-3">
        <div class="head">{{ data.email }}</div>
      </div>
    </div>

    <div class="row d-flex align-items-center text-capitalize justify-content-center my-4">
      <div class="col-sm-3">
        <div class="label">GST</div>
      </div>
      <div class="col-sm-3">
        <div class="head">{{ data.gst }}</div>
      </div>
      <div class="col-sm-3">
        <div class="label">PAN</div>
      </div>
      <div class="col-sm-3 class-name">
        <div class="head">{{ data.pan }}</div>
      </div>
    </div>

    <div class="row d-flex text-capitalize my-4">
      <div class="col-sm-3">
        <div class="label">Company Name</div>
      </div>
      <div class="col-sm-9">
        <div class="head">{{ data.company_name }}</div>
      </div>
    </div>

    <div class="d-flex justify-content-between align-items-center">
      <div class="notification-header">
        <h5 class="text-capitalize underline">Account Details :-</h5>
      </div>
    </div>

    <div class="row d-flex align-items-center text-capitalize justify-content-center my-4">
      <div class="col-sm-3">
        <div class="label">Account Name</div>
      </div>
      <div class="col-sm-3">
        <div class="head">{{ data.account_details?.account_name }}</div>
      </div>
      <div class="col-sm-3">
        <div class="label">Account Number</div>
      </div>
      <div class="col-sm-3 class-name">
        <div class="head">{{ data.account_details?.accountr_number }}</div>
      </div>
    </div>
    <div class="row d-flex align-items-center text-capitalize justify-content-center my-4">
      <div class="col-sm-3">
        <div class="label">Bank Name</div>
      </div>
      <div class="col-sm-3">
        <div class="head">{{ data.account_details?.bank_name }}</div>
      </div>
      <div class="col-sm-3">
        <div class="label">Branch Name</div>
      </div>
      <div class="col-sm-3 class-name">
        <div class="head">{{ data.account_details?.branch_name }}</div>
      </div>
    </div>
    <div class="row d-flex align-items-center text-capitalize justify-content-center my-4">
      <div class="col-sm-3">
        <div class="label">IFSC Code</div>
      </div>
      <div class="col-sm-3">
        <div class="head">{{ data.account_details?.ifsc_code }}</div>
      </div>
      <div class="col-sm-3">
        <div class="label">Created Date</div>
      </div>
      <div class="col-sm-3 class-name">
        <div class="head">
          {{ data?.createdAt | date : "dd-MM-yyyy" }}
        </div>
      </div>
    </div>

    <!-- Cancelled Cheque Row -->
    <div class="row d-flex align-items-center text-capitalize justify-content-center my-4"
      *ngIf="data.account_details?.cancelled_cheque">
      <div class="col-sm-3">
        <div class="label">Cancelled Cheque</div>
      </div>
      <div class="col-sm-9">
        <div class="cheque-container">
          <a [href]="data.account_details?.cancelled_cheque" target="_blank">
            <img [src]="data.account_details?.cancelled_cheque" class="cheque-img" />
          </a>
        </div>
      </div>
    </div>

    <!-- Approve and Reject Buttons -->
    <div class="row d-flex align-items-center text-capitalize justify-content-center my-4"
      *ngIf="data.loginInfo[0]?.login_status == 'inactive'">
      <div class="col-sm-12 text-center">
        <button class="approve_btn_custom" (click)="approve()" [disabled]="loading">
          {{ loading ? "Approving..." : "Approve" }}
        </button>
        <button class="reject_btn_custom" (click)="reject()" [disabled]="loading">
          Reject
        </button>
      </div>
    </div>
  </div>
</div>